import { render, staticRenderFns } from "./restaurantDashboard.vue?vue&type=template&id=0b456856&scoped=true&"
import script from "./restaurantDashboard.vue?vue&type=script&lang=js&"
export * from "./restaurantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./restaurantDashboard.vue?vue&type=style&index=0&id=0b456856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b456856",
  null
  
)

export default component.exports